import Roles from '../../contants/Roles';
import AuthService from '../../services/AuthService';

interface IProps {
    roles?: Roles[];
    userRoles?: boolean;
    children: any;
}

const CanAccess = ({ roles, userRoles, children }: IProps) => {

    function hasPermission() {
        return AuthService.hasPermission(userRoles ? getUserRoles() : roles);
    }

    const getUserRoles = () => [Roles.Admin, Roles.User, Roles.Manager, Roles.Consultant, Roles.Master, Roles.Partner];

    if (!hasPermission())
        return null;

    return (children);
};

export default CanAccess;